module.exports = __webpack_public_path__ + "static/img/skin-panel.515b44c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/skin/skin-panel.png
// module id = jzDr
// module chunks = 2